
import { CreateConnectionMediumDto, FormConnectionMediumDto, RowConnectionMediumDto, UpdateConnectionMediumDto } from "@/dtos";
import { Chip, ConnectionMedium, DecodingAlgorithm, Vehicle } from "@/entities";
import { ConnectionMediumOrigin } from "@/helpers/types";

export const formatRowConnectionMediumDto = async (connectionmedium: ConnectionMedium[], stop?: string): Promise<RowConnectionMediumDto[]> => {
    return connectionmedium.map((x) => {
        const row: RowConnectionMediumDto = {
            ...x,
            name: x.origin == ConnectionMediumOrigin.VEHICLE ? x.vehicle.name : stop,
            chip_name: x.chip.name,
            decoding_algorithm_name: x.decoding_algorithm.name,
            active: x.is_active ? 'Activo' : 'Inactivo',
        }
        return row;
    });
}

export const formatConnectionMediumDto = async (formConnectionMedium: FormConnectionMediumDto, isCreate: boolean) => {
    const decoding_algorithm = { id: formConnectionMedium.decoding_algorithm_id } as DecodingAlgorithm;
    const vehicle = { id: formConnectionMedium.vehicle_id } as Vehicle;
    const chip = { id: formConnectionMedium.chip_id } as Chip;

    const connectionMediumDto = {
        identification: formConnectionMedium.identification,
        decoding_algorithm: decoding_algorithm,
        vehicle: vehicle,
        stop_id: formConnectionMedium.stop_id,
        origin: formConnectionMedium.vehicle_id ? ConnectionMediumOrigin.VEHICLE : ConnectionMediumOrigin.STOP,
        connection: [],
        chip: chip
    }

    return (isCreate) ? connectionMediumDto as CreateConnectionMediumDto :
        connectionMediumDto as UpdateConnectionMediumDto;
}
